import { Component } from '@angular/core';
import { FacilityConfigConstants } from '../models/constants/facility-config.constants';
import {
  PanelContainerComponent,
  PanelBodyComponent,
  PanelHeaderComponent,
} from 'src/app/shared/content-panels';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  FacilityDataModel,
  FacilityStationModel,
} from '../models/facility-config.model';
import { FacilityConfigService } from '../services/facility-config.service';
import { QBuiltService } from '../../qbuilt/services/qbuilt-service';
import { Router } from '@angular/router';
import { localStorageConstants } from 'src/app/shared/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'facility-config',
  imports: [
    PanelContainerComponent,
    PanelBodyComponent,
    PanelHeaderComponent,
    MatIconModule,
    MatExpansionModule,
  ],
  templateUrl: './facility-config.component.html',
  styleUrl: './facility-config.component.scss',
})
export class FacilityConfigComponent {
  panelHeading: string = this.facilityConfigConstants.fcPanelHeading;
  emptyZoneText: string = this.facilityConfigConstants.fcEmptyZoneText3;

  hasConfiguration: boolean = false;
  panelOpenState = false;

  facilityData: FacilityDataModel[] = [];
  facilityDisplayData: FacilityDataModel[] = [];
  activeStationList: FacilityStationModel[] = [];

  facilityNumber: string;
  private _subscriptions: Subscription[] = [];

  constructor(
    private facilityConfigConstants: FacilityConfigConstants,
    private facilityConfigService: FacilityConfigService,
    private router: Router,
    private qbuiltService: QBuiltService,
  ) {}

  ngOnInit() {
    //get facility number
    this.qbuiltService.setFacilityNumber(
      localStorageConstants.USER_FACILITIES_KEY,
    );
    this.qbuiltService.facilityNumber$.subscribe((facilityNumber) => {
      this.facilityNumber = facilityNumber;
      sessionStorage.setItem('facilityNumber', this.facilityNumber);
    });
    //check to see if user already has data
    this.checkForConfigurationData(this.facilityNumber);
  }

  checkForConfigurationData(facilityNumber: string) {
    //if user has data then display the configuration on page
    this.facilityConfigService.getConfigurationData(facilityNumber);
    let sub = this.facilityConfigService.facilityData$.subscribe(
      (data: FacilityDataModel[]) => {
        this.facilityDisplayData = data.map((item) => ({
          HBGFacilityNumber: item.HBGFacilityNumber,
          Id: item.Id,
          Name: item.Name,
          OrderOfExecution: item.OrderOfExecution,
          Stations: item.Stations.map((station) => ({
            ...station,
            OrderOfExecution: station.OrderOfExecution,
            InspectionTasks: station.InspectionTasks.map((task) => ({
              ...task,
            })),
          })),
        }));
        this.hasConfiguration = data && data.length > 0;
        sessionStorage.setItem(
          'hasConfiguration',
          JSON.stringify(this.hasConfiguration),
        );
        sessionStorage.setItem(
          'facilityData',
          JSON.stringify(
            this.facilityDisplayData.sort(
              (a, b) => a.OrderOfExecution - b.OrderOfExecution,
            ),
          ),
        );
        this.facilityConfigService.setHasConfiguration(this.hasConfiguration);
      },
    );
    this._subscriptions.push(sub);
  }

  //** Edit Facility Configuration
  // Routes user to 'New' if hasConfiguration === false
  // Routes to 'Edit' if hasConfiguration === true
  onEdit() {
    if (!this.hasConfiguration) {
      this.router.navigate(['/facility-configuration/new']);
    } else {
      let id = this.facilityDisplayData[0]?.Id;
      this.router.navigate(['/facility-configuration/edit', id]);
    }
  }

  formatItemCount(station: any): string {
    let total = 0;
    station.forEach((item: any) => {
      total += item.InspectionTasks.length;
    });
    return `(${total} items)`;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
